import React, { createContext, useContext, useReducer } from "react";
import { ShowContactAction, ShowContactState } from "./PageContext.model";
import Layout from "@/page/Layout/Layout";
import { LayoutProps } from "@/page/Layout/Layout.model";

const initialState = { showContact: false };
const PageContext = createContext<{
  state: ShowContactState;
  dispatch: React.Dispatch<ShowContactAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

const reducer = (state: ShowContactState, action: ShowContactAction) => {
  switch (action.type) {
    case "SET_CONTACT_STATUS":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const PageContextProvider = ({ children, data }: LayoutProps) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <PageContext.Provider value={{ state, dispatch }}>
      <Layout data={data}>{children}</Layout>
    </PageContext.Provider>
  );
};

export const usePageContext = () => useContext(PageContext);
